const PLAN_LABELS = {
  free: "Free",
  standard: "Standard",
  pro: "Pro",
  elite: "Elite",
  ultimate: "Ultimate",
  dev: "Dev",
};

function formatPlanLabel(plan) {
  const key = String(plan ?? "").trim().toLowerCase();
  if (!key) return null;

  if (/^price[_-]/i.test(key)) return null;

  if (PLAN_LABELS[key]) return PLAN_LABELS[key];
  if (key.includes("ultimate")) return "Ultimate";
  if (key.includes("elite")) return "Elite";
  if (key.includes("pro")) return "Pro";
  if (key.includes("standard")) return "Standard";
  if (key.includes("free")) return "Free";

  return key.charAt(0).toUpperCase() + key.slice(1);
}

const GENERIC_PLAN_LABELS = new Set([
  "purchase",
  "kauf",
  "plan purchase",
  "plan-kauf",
  "v3tax purchase",
  "v3tax kauf",
  "plan unknown",
  "plan unbekannt",
  "unknown",
  "unbekannt",
  "free",
]);

function cleanSubApplication(value) {
  let s = String(value || "").trim();
  if (!s) return "";

  s = s.replace(/^V3Tax\s*/i, "").trim();
  s = s.replace(/^(plan\s*)?(purchase|kauf)\s*[·:|-]?\s*/i, "").trim();

  return s;
}

/** Nur echter Plan aus DB/Meta, immer Title Case. */
export function resolveV3TaxPlanName(tx = {}) {
  const candidates = [
    tx.v3taxPlanName,
    tx.v3tax_plan_name,
    tx.planName,
    tx.plan_name,
    cleanSubApplication(tx.subApplication || tx.sub_application),
    tx.v3taxPlanId,
    tx.v3tax_plan_id,
    tx.planId,
    tx.plan_id,
  ].filter((v) => v !== null && v !== undefined && String(v).trim() !== "");

  for (const raw of candidates) {
    const label = formatPlanLabel(raw);
    if (!label) continue;
    if (GENERIC_PLAN_LABELS.has(label.toLowerCase())) continue;
    return label;
  }

  return null;
}

export function formatV3TaxPurchaseSubline(tx, language = "de") {
  const plan = resolveV3TaxPlanName(tx);

  if (plan) {
    return language === "de"
      ? `Plan-Kauf · ${plan}`
      : `Plan purchase · ${plan}`;
  }

  return language === "de" ? "Plan-Kauf" : "Plan purchase";
}
